export enum CardApplicationReason {
  IssuanceFirstTime = 1,
  IssuanceInCaseOfTheft = 2,
  IssuanceInCaseOfLoss = 3,
  ExpirationDate = 4,
  ChangingHolderDetails = 5,
  // Unsuitable for use. The record is created when the card is blocked.
  UnsuitabilityForUse = 6,
  Return = 7,
  Prerequested = 9,
}
